<template>
  <v-app>
    <app-nav-bar />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
import Vue from 'vue'
import AppNavBar from '@/components/navbar.vue'
import Loading from '@/components/loading.vue'

Vue.component('loading', Loading)

export default {
  components: {
    AppNavBar,
  },
}
</script>
